module.exports = __webpack_public_path__ + "static/assets/9372a1bc8bef2253d9ce71a7d2e34935.gif";